function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { DEFAULT_TPL_FIELDS, METADATA_FILE_FORMAT, BUCKET_DIRECTORY_TYPES, METADATA_IMAGE_FORMAT, ROLES_LIST } from '@/js/constants';
import DatastudioReportService from '@/apps/data-platform/services/visualization/datastudio_report_service';
import FilesService from '@/apps/data-platform/services/security/files_service';
import { ACCESS_TYPE_FLOW, ENVIRONMENT_FLOW } from '@/js/constants';
import tasks from '@/js/tasks';
export default {
  name: 'ReportTabGeneral',
  props: {
    item: {
      type: Object,
      default: function _default() {}
    },
    readonly: {
      type: Boolean,
      default: false
    },
    isChangeRequest: {
      type: String,
      default: ''
    },
    valid: {
      type: Object,
      default: function _default() {
        return {
          organization: true,
          database_engine: true,
          data_operator: true,
          kdomain: true,
          ksubdomain: true,
          object_description: true,
          response_text: true,
          tab: null
        };
      }
    },
    show_url: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      DEFAULT_TPL_FIELDS: DEFAULT_TPL_FIELDS,
      METADATA_FILE_FORMAT: METADATA_FILE_FORMAT,
      METADATA_IMAGE_FORMAT: METADATA_IMAGE_FORMAT,
      environ_initial: '',
      files: [],
      inputUploadFile: null,
      inputUploadImage: null,
      currentFile: {},
      isHovered: false,
      requiredFlag: null
    };
  },
  computed: _objectSpread({
    filterSubDomain: function filterSubDomain() {
      var _this = this;
      var selectbSubdomain = this.selectSubdomain.filter(function (Subdomain) {
        return Subdomain.domain.includes(_this.item.kdomain);
      });
      return selectbSubdomain;
    },
    isShowWorkFlow: function isShowWorkFlow() {
      return this.isChangeRequest === 'APPROVE_OWNER';
    },
    get_paths: function get_paths() {
      return this.item && this.item.datasource_path ? this.item.datasource_path.split(',') : [];
    }
  }, mapState('data-platform', ['selectDomain', 'selectSubdomain', 'organizations'])),
  created: function created() {
    this.domain_table = window.userInfo.domain;
    this.environ_initial = this.item['environment'];
    this.files = this.item.files || [];
    this.getPreviewImage();
    if (this.selectDomain.length == 0) {
      this.$store.dispatch('data-platform/getBusinessDomainQuery');
    }
    this.requiredFlag = this.isChangeRequest === ACCESS_TYPE_FLOW.CHANGE_METADATA || this.item.environment === ENVIRONMENT_FLOW.PROD;
    console.log("flag: ", this.requiredFlag);
  },
  methods: {
    cantUploadPreview: function cantUploadPreview() {
      var userInfo = window.userInfo;
      var roles = userInfo.userRoles;
      if (roles.filter(function (r) {
        return r == ROLES_LIST["ORG_DATA_STEWARD"];
      }).length > 0) {
        return true;
      }
      if (this.item.data_operator == userInfo.email) {
        return true;
      }
      return false;
    },
    onFileChange: function onFileChange(event) {
      var _this2 = this;
      var file = event.target.files[0];
      var fileReader = new FileReader();
      if (!file || file === undefined) {
        return;
      }
      fileReader.onload = function (e) {
        var filename = file.name;
        var data = {
          content: e.target.result,
          filename: "".concat(_this2.item.luid, "/files/").concat(filename),
          name: filename,
          type: BUCKET_DIRECTORY_TYPES.REPORTS,
          domain_source: _this2.domain_table
        };
        if (_this2.item.report_id) {
          FilesService.uploadFile(data).then(function (res) {
            if (res['success']) {
              var _file = {
                domainTable: _this2.domain_table,
                fileLink: res['data'] && res['data']['public_url'] || '',
                fileId: res['data'] && res['data']['file_id'] || '',
                fileName: res['data'] && res['data']['filename'] || ''
              };
              _this2.files.push(_file);
              _this2.updateFiles();
              _this2.inputUploadFile = null;
            } else {
              _this2.inputUploadFile = null;
              tasks.toast.error(res['message']);
              //this.$toast.warning(res['message'])
            }
          });
        } else {
          // es un registro nuevo
          var _file2 = {
            domainTable: _this2.domain_table,
            fileLink: '',
            fileId: '',
            fileContent: data,
            name: filename,
            fileName: data.filename
          };
          _this2.files.push(_file2);
          _this2.item['files'] = _this2.files;
        }
      };
      fileReader.readAsDataURL(file);
    },
    updateFiles: function updateFiles() {
      var _this3 = this;
      this.item['files'] = this.files;
      var report = {
        domain: window.userInfo.domain,
        report: this.item
      };
      DatastudioReportService.reportAddUpdate(report).then(function (res) {
        _this3.isSend = false;
        if (res && res.code === 200) {
          if (!res.success) {
            tasks.toast.success(res['message']);
            //this.$toast.success(res.message)
          }
        }
      });
    },
    onFileChangeImage: function onFileChangeImage(event) {
      var _this4 = this;
      var file = event.target.files[0];
      var fileReader = new FileReader();
      if (!file || file === undefined) {
        return;
      }
      fileReader.onload = function (e) {
        var filename = file.name;
        var data = {
          content: e.target.result,
          filename: "".concat(_this4.item.luid, "/preview/").concat(filename),
          name: filename,
          type: BUCKET_DIRECTORY_TYPES.REPORTS,
          domain_source: _this4.domain_table
        };
        if (_this4.item.report_id) {
          FilesService.uploadFile(data).then(function (res) {
            if (res['success']) {
              var _file3 = {
                domainTable: _this4.domain_table,
                fileLink: res['data'] && res['data']['public_url'] || '',
                fileId: res['data'] && res['data']['file_id'] || '',
                fileName: res['data'] && res['data']['filename'] || ''
              };
              _this4.$set(_this4.item, 'preview_image', _file3.fileLink);
              _this4.updateImage();
              _this4.inputUploadImage = null;
            } else {
              _this4.inputUploadImage = null;
              tasks.toast.error(res['message']);
              //this.$toast.warning(res['message'])
            }
          });
        } else {
          var preview_data = {
            content: data,
            filename: filename
          };
          console.log(preview_data);
          _this4.item.preview_data = preview_data;
        }
      };
      fileReader.readAsDataURL(file);
    },
    updateImage: function updateImage() {
      var _this5 = this;
      var report = {
        domain: window.userInfo.domain,
        report: this.item
      };
      console.log(report.report);
      DatastudioReportService.reportAddUpdate(report).then(function (res) {
        _this5.isSend = false;
        console.log(res);
        if (res && res.code === 200) {
          if (!res.success) {
            tasks.toast.error(res['message']);
            //this.$toast.error(res.message)
          } else {
            tasks.toast.success('Successful request!');
            //this.$toast.success('Successful request!')
            _this5.getPreviewImage();
          }
        }
      });
    },
    deleteFile: function deleteFile(record) {
      var _this6 = this;
      if (record.fileId) {
        FilesService.deleteFile(record).then(function (res) {
          var files = _this6.files;
          _this6.files = files.filter(function (file) {
            return file.fileId !== record.fileId;
          });
          _this6.updateFiles();
        }).then(function () {
          _this6.currentFile = {};
        });
      }
    },
    onClickLink: function onClickLink(file) {
      var _this7 = this;
      FilesService.readFile(file.fileLink).then(function (response) {
        _this7.isLoading = false;
        if (response.success) {
          _this7.image = response.data.base64;
          _this7.dataImage = response.data;
          _this7.filename = response.data.name.split('/').pop();
          _this7.contentType = response.data.contentType;
          _this7.currentFile = {
            fileLink: response.data.base64,
            fileName: response.data.name.split('/').pop(),
            contentType: response.data.contentType
          };
          _this7.$bvModal.show('preview-file');
        } else {
          _this7.currentFile = {
            fileLink: null,
            fileName: null,
            contentType: null
          };
          tasks.toast.error(response.message);
          //alert(response.message)
        }
      });
    },
    openImage: function openImage(url) {
      var uriObj = {
        name: 'DisplayImage',
        query: {
          uris: url
        }
      };
      var urlNew = this.$router.resolve(uriObj);
      window.open(urlNew.href, '_blank');
    },
    getPreviewImage: function getPreviewImage() {
      var _this8 = this;
      if (this.item.preview_image) {
        FilesService.readFile(this.item.preview_image).then(function (response) {
          _this8.$set(_this8.item, 'report_image', response.data.base64);
        });
      }
    },
    isUrlExists: function isUrlExists(url) {
      var _this9 = this;
      if (!url) return;
      DatastudioReportService.checkAccessLink({
        "url": url
      }).then(function (response) {
        if (response.success) {
          _this9.$set(_this9.item, 'urlStatus', true);
        } else {
          _this9.$set(_this9.item, 'urlStatus', false);
        }
      });
    },
    changeUrl: function changeUrl() {
      this.$set(this.item, 'urlStatus', null);
    }
  }
};